export default "__VITE_ASSET__BoVDhGD0__"